import React from 'react';

const InitiativesTable = ({ columns = [], rows = [], onProjectClick }) => {
  if (!rows.length) {
    return <div className="initiatives-jklc__empty">No data available</div>;
  }

  return (
    <div className="initiatives-jklc__table-wrap">
      <table className="initiatives-jklc__table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} style={{ width: col.width }}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={row.project_id || idx}>
              {columns.map((col) => {
                const value = row[col.key];
                const isLink =
                  col.key === 'project_id' &&
                  row.clickable === true &&
                  typeof onProjectClick === 'function';
                return (
                  <td key={col.key}>
                    {isLink ? (
                      <span
                        className="initiatives-jklc__link"
                        onClick={() => onProjectClick(row)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') onProjectClick(row);
                        }}
                      >
                        {value}
                      </span>
                    ) : (
                      value
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InitiativesTable;
